<template>
  <div>
    <el-card
      class="box-card receivables-list-card common-card-properties"
      v-loading="getReceivablesLoading"
      element-loading-text="Loading receivables...">
      <el-row
        :gutter="10"
        style="width:100%;"
        class="table-caption">
        <el-col :span="18">
          <div class="caption-box">
            <span class="pending-box"></span> = Pending
            <span class="paid-box"></span> = Paid
            <i class="el-icon-warning yellow"></i> = Due in a week or less
            <i class="el-icon-warning red"></i> = Past due
          </div>
        </el-col>
        <el-col
        :span="6">
          <el-button
            type="success"
            class="btn-block"
            @click="openCreateDialog">
            <i class="fa fa-plus"></i> ADD RECEIVABLE
          </el-button>
        </el-col>
      </el-row>
      <el-row
        :gutter="10"
        style="width:100%;"
        class="table-caption">
        <el-col
          :span="12"
          :offset="6">
          <el-pagination
            @size-change="handleReceivableListSizeChange"
            @current-change="handleReceivableListCurrentChange"
            :current-page="getReceivableTransactionsPagination.page"
            :page-sizes="getCurrentPageSizes"
            :page-size="getReceivableTransactionsPagination.perPage"
            layout="prev, pager, next, sizes"
            :total="getReceivableTransactionsPagination.total">
          </el-pagination>
        </el-col>
      </el-row>
      <el-table
        class="table-receivables"
        :data="getReceivableTransactions"
        border
        :default-sort = "{prop: 'status', order: 'ascending'}"
        style="width: 100%"
        @header-click="sortBy">
        <div
          slot="empty"
          class="not-found-message">
          No Receivable found
        </div>
        <el-table-column
          label="Reference"
          width="130"
          prop="id"
          show-overflow-tooltip>
          <template slot-scope="scope">
            <router-link
              :to="{ name: 'rt-detail', params: { id: scope.row.receivableId }}"
              :class="scope.row.receivableStatus == 'paid' ? 'green' : 'yellow'"
              :id="scope.row.receivableReference">
              {{ scope.row.receivableReference }}
            </router-link>
          </template>
        </el-table-column>
        <el-table-column
          label="Transaction"
          width="110"
          show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.receivableIndex.position }} / {{ scope.row.receivableIndex.total }}
          </template>
        </el-table-column>
        <el-table-column
          label="Status"
          sortable
          prop="status"
          show-overflow-tooltip>
          <template slot-scope="scope">
            <el-tag
              style="text-transform:uppercase;"
              v-if="scope.row.status === 'confirmed'"
              type="success">
              Confirmed
            </el-tag>
            <el-tag
              class="pending-confirmation"
              style="text-transform:uppercase;"
              v-if="scope.row.status === 'pending-confirmation'">
              Pending<br>Confirmation
            </el-tag>
            <el-tag
              style="text-transform:uppercase;"
              v-if="scope.row.status === 'pending'"
              type="warning">
              Pending
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          label="Customer"
          width="130"
          prop="id"
          show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.customer.name }}
          </template>
        </el-table-column>
        <el-table-column
          label="Due"
          sortable
          show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.due">
              <span v-if="scope.row.receivableStatus !== 'paid'">
                <i
                  class="el-icon-warning yellow"
                  v-if="checkDueDate(scope.row.due, scope.row.status)">
                </i>
                <i
                  class="el-icon-warning red"
                  v-else-if="pastDue(scope.row.due, scope.row.status)">
                </i>
              </span>
              {{ scope.row.due | moment('DD/MM/YYYY') }}
            </span>
            <span v-else>No due date defined</span>
          </template>
        </el-table-column>
        <el-table-column
          label="Days left"
          show-overflow-tooltip
          width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.due && scope.row.status != 'confirmed'">
              <span v-if="!pastDue(scope.row.due, scope.row.status)">
                {{ scope.row.due | moment("add", "1 day", 'from', 'now') }}
              </span>
              <span
                v-else-if="scope.row.receivableStatus !== 'paid'"
                style="color:#E74C3C;">
                PAST DUE
              </span>
              <span v-else>-</span>
            </span>
          </template>
        </el-table-column>
        <el-table-column
          label="Amount"
          show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.amount | currency }}</span>
          </template>
        </el-table-column>
      </el-table>
      <br>
      <el-row
        :gutter="10"
        style="width:100%;"
        class="table-caption">
        <el-col :span="12">
          <div class="caption-box">
            <span class="pending-box"></span> = Pending
            <span class="paid-box"></span> = Paid
            <i class="el-icon-warning yellow"></i> = Due in a week or less
            <i class="el-icon-warning red"></i> = Past due
          </div>
        </el-col>
        <el-col :span="12">
          <el-pagination
            @size-change="handleReceivableListSizeChange"
            @current-change="handleReceivableListCurrentChange"
            :current-page="getReceivableTransactionsPagination.page"
            :page-sizes="getCurrentPageSizes"
            :page-size="getReceivableTransactionsPagination.perPage"
            layout="prev, pager, next, sizes"
            :total="getReceivableTransactionsPagination.total">
          </el-pagination>
        </el-col>
      </el-row>
    </el-card>
    <zeeCreateReceivable></zeeCreateReceivable>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import * as moment from 'moment';

import zeeCreateReceivable from './CreateReceivable.vue';

export default {
  components: {
    zeeCreateReceivable,
  },
  data() {
    return {
      createModalVisible: false,
      order: false,
      orderKey: '',
    };
  },
  computed: {
    ...mapGetters({
      getReceivableTransactions: 'getReceivableTransactions',
      getReceivablesLoading: 'getReceivablesLoading',
      getReceivableTransactionsPagination: 'getReceivableTransactionsPagination',
    }),
    getCurrentPageSizes() {
      return [10, 25, 50, 100];
    },
  },
  methods: {
    ...mapActions({
      setNewReceivableModalVisibility: 'setNewReceivableModalVisibility',
      updateReceivableOrderBy: 'updateReceivableOrderBy',
      getSearchedReceivableTransactionsData: 'getSearchedReceivableTransactionsData',
    }),
    openCreateDialog() {
      return this.setNewReceivableModalVisibility(true);
    },
    checkDueDate(due, status) {
      if ((status !== 'confirmed') && (moment(due).diff(moment(), 'days') <= 7) && (moment(due).diff(moment(), 'seconds') > 0 || moment(due).diff(moment(), 'days') === 0)) {
        return true;
      } return false;
    },
    pastDue(due, status) {
      if (status !== 'confirmed' && moment(due).diff(moment(), 'seconds') < 0 && moment(due).diff(moment(), 'days') !== 0) {
        return true;
      } return false;
    },
    handleReceivableListSizeChange(val) {
      if (val !== this.getReceivableTransactionsPagination.perPage) {
        const paginationObj = {};
        paginationObj.perPage = val;
        paginationObj.page = this.getReceivableTransactionsPagination.page;
        this.$store.dispatch('updateReceivableTransactionsPagination', paginationObj);
        this.$store.dispatch('getSearchedReceivableTransactionsData');
      }
    },
    handleReceivableListCurrentChange(val) {
      if (val !== this.getReceivableTransactionsPagination.page) {
        const paginationObj = {};
        paginationObj.perPage = this.getReceivableTransactionsPagination.perPage;
        paginationObj.page = val;
        this.currentPage = val;
        this.$store.dispatch('updateReceivableTransactionsPagination', paginationObj);
        this.$store.dispatch('getSearchedReceivableTransactionsData', true);
      }
    },
    sortBy(column) {
      if (typeof column.label !== 'undefined') {
        let key = '';
        let orderBy = '';
        switch (column.label) {
          case 'Status':
            key = 'status';
            break;
          case 'Due':
            key = 'due';
            break;
          default:
            break;
        }

        if (!this.order) {
          orderBy = `&o=${key}`;
        } else {
          orderBy = `&o=-${key}`;
        }
        if (key !== '') {
          this.orderKey = key;
          this.order = !this.order;
          this.updateReceivableOrderBy(orderBy);
          this.getSearchedReceivableTransactionsData();
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.el-pagination {
  text-align: center;
}
.cell a {
  border-bottom: 1px solid;
  text-decoration: none;
  &.green {
    color:#1ABB9C;
    border-color: #1ABB9C;
  }
  &.yellow {
    color: #f7ba2a;
    border-color: #f7ba2a;
  }
}
.paid-box, .pending-box {
  width: 15px;
  height: 15px;
  display: inline-block;
  margin: 0 5px;
}
.paid-box {
  background-color: #1ABB9C;
}
.pending-box {
  background-color: #f7ba2a;
}
.caption-box {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  i {
    margin: 0 5px;
    font-size: 1.3em;
  }
}
.el-icon-warning.yellow {
  color:#f7ba2a;
}
.table-caption{
  padding:5px 0 20px 0;
}
.table-receivables .pending-confirmation{
  height:40px;
  line-height: 18px;
}
</style>



// WEBPACK FOOTER //
// src/components/receivables/partials/ReceivablesList.vue